import { handleDeepLinking, updateEnvironment } from '../actions/App'
import store from '../index'

const { dispatch } = store

export const dispatchHandleDeepLinking = data =>
    dispatch(handleDeepLinking(data))

export const dispatchUpdateEnvironment = value =>
    dispatch(updateEnvironment(value))
